var React = require('react');

function InstagramIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7.8 2h8.4c3.2 0 5.8 2.6 5.8 5.8v8.4c0 3.2-2.6 5.8-5.8 5.8h-8.4c-3.2-.001-5.8-2.6-5.8-5.8v-8.4c0-3.21 2.59-5.8 5.8-5.8m-.2 2v-.01c-1.99 0-3.6 1.61-3.6 3.6v8.8c0 1.99 1.61 3.6 3.6 3.6h8.8c1.98 0 3.6-1.62 3.6-3.6v-8.8c0-1.99-1.61-3.6-3.6-3.6h-8.8m9.65 1.5c.69 0 1.25.55 1.25 1.25 0 .69-.56 1.25-1.25 1.25-.7 0-1.25-.56-1.25-1.25 0-.7.55-1.25 1.25-1.25m-5.25 1.5c2.76 0 5 2.23 5 5 0 2.76-2.24 5-5 5-2.77 0-5-2.24-5-5 0-2.77 2.23-5 5-5m0 2c-1.66 0-3 1.34-3 3 0 1.65 1.34 3 3 3 1.65 0 3-1.35 3-3 0-1.66-1.35-3-3-3z"}));
}

InstagramIconInline.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = InstagramIconInline;

InstagramIconInline.default = InstagramIconInline;
